/* eslint-disable */
// prettier-ignore
/**
 * Minified by jsDelivr using Terser v5.37.0.
 * Original file: /gh/exif-heic-js/exif-heic-js@1.0.2/exif-heic.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */

const debug = !1;
let ExifTags = {
    36864: "ExifVersion",
    40960: "FlashpixVersion",
    40961: "ColorSpace",
    40962: "PixelXDimension",
    40963: "PixelYDimension",
    37121: "ComponentsConfiguration",
    37122: "CompressedBitsPerPixel",
    37500: "MakerNote",
    37510: "UserComment",
    40964: "RelatedSoundFile",
    36867: "DateTimeOriginal",
    36868: "DateTimeDigitized",
    37520: "SubsecTime",
    37521: "SubsecTimeOriginal",
    37522: "SubsecTimeDigitized",
    33434: "ExposureTime",
    33437: "FNumber",
    34850: "ExposureProgram",
    34852: "SpectralSensitivity",
    34855: "ISOSpeedRatings",
    34856: "OECF",
    37377: "ShutterSpeedValue",
    37378: "ApertureValue",
    37379: "BrightnessValue",
    37380: "ExposureBias",
    37381: "MaxApertureValue",
    37382: "SubjectDistance",
    37383: "MeteringMode",
    37384: "LightSource",
    37385: "Flash",
    37396: "SubjectArea",
    37386: "FocalLength",
    41483: "FlashEnergy",
    41484: "SpatialFrequencyResponse",
    41486: "FocalPlaneXResolution",
    41487: "FocalPlaneYResolution",
    41488: "FocalPlaneResolutionUnit",
    41492: "SubjectLocation",
    41493: "ExposureIndex",
    41495: "SensingMethod",
    41728: "FileSource",
    41729: "SceneType",
    41730: "CFAPattern",
    41985: "CustomRendered",
    41986: "ExposureMode",
    41987: "WhiteBalance",
    41988: "DigitalZoomRation",
    41989: "FocalLengthIn35mmFilm",
    41990: "SceneCaptureType",
    41991: "GainControl",
    41992: "Contrast",
    41993: "Saturation",
    41994: "Sharpness",
    41995: "DeviceSettingDescription",
    41996: "SubjectDistanceRange",
    40965: "InteroperabilityIFDPointer",
    42016: "ImageUniqueID",
  },
  TiffTags = {
    256: "ImageWidth",
    257: "ImageHeight",
    34665: "ExifIFDPointer",
    34853: "GPSInfoIFDPointer",
    40965: "InteroperabilityIFDPointer",
    258: "BitsPerSample",
    259: "Compression",
    262: "PhotometricInterpretation",
    274: "Orientation",
    277: "SamplesPerPixel",
    284: "PlanarConfiguration",
    530: "YCbCrSubSampling",
    531: "YCbCrPositioning",
    282: "XResolution",
    283: "YResolution",
    296: "ResolutionUnit",
    273: "StripOffsets",
    278: "RowsPerStrip",
    279: "StripByteCounts",
    513: "JPEGInterchangeFormat",
    514: "JPEGInterchangeFormatLength",
    301: "TransferFunction",
    318: "WhitePoint",
    319: "PrimaryChromaticities",
    529: "YCbCrCoefficients",
    532: "ReferenceBlackWhite",
    306: "DateTime",
    270: "ImageDescription",
    271: "Make",
    272: "Model",
    305: "Software",
    315: "Artist",
    33432: "Copyright",
  },
  GPSTags = {
    0: "GPSVersionID",
    1: "GPSLatitudeRef",
    2: "GPSLatitude",
    3: "GPSLongitudeRef",
    4: "GPSLongitude",
    5: "GPSAltitudeRef",
    6: "GPSAltitude",
    7: "GPSTimeStamp",
    8: "GPSSatellites",
    9: "GPSStatus",
    10: "GPSMeasureMode",
    11: "GPSDOP",
    12: "GPSSpeedRef",
    13: "GPSSpeed",
    14: "GPSTrackRef",
    15: "GPSTrack",
    16: "GPSImgDirectionRef",
    17: "GPSImgDirection",
    18: "GPSMapDatum",
    19: "GPSDestLatitudeRef",
    20: "GPSDestLatitude",
    21: "GPSDestLongitudeRef",
    22: "GPSDestLongitude",
    23: "GPSDestBearingRef",
    24: "GPSDestBearing",
    25: "GPSDestDistanceRef",
    26: "GPSDestDistance",
    27: "GPSProcessingMethod",
    28: "GPSAreaInformation",
    29: "GPSDateStamp",
    30: "GPSDifferential",
  },
  StringValues = {
    ExposureProgram: {
      0: "Not defined",
      1: "Manual",
      2: "Normal program",
      3: "Aperture priority",
      4: "Shutter priority",
      5: "Creative program",
      6: "Action program",
      7: "Portrait mode",
      8: "Landscape mode",
    },
    MeteringMode: {
      0: "Unknown",
      1: "Average",
      2: "CenterWeightedAverage",
      3: "Spot",
      4: "MultiSpot",
      5: "Pattern",
      6: "Partial",
      255: "Other",
    },
    LightSource: {
      0: "Unknown",
      1: "Daylight",
      2: "Fluorescent",
      3: "Tungsten (incandescent light)",
      4: "Flash",
      9: "Fine weather",
      10: "Cloudy weather",
      11: "Shade",
      12: "Daylight fluorescent (D 5700 - 7100K)",
      13: "Day white fluorescent (N 4600 - 5400K)",
      14: "Cool white fluorescent (W 3900 - 4500K)",
      15: "White fluorescent (WW 3200 - 3700K)",
      17: "Standard light A",
      18: "Standard light B",
      19: "Standard light C",
      20: "D55",
      21: "D65",
      22: "D75",
      23: "D50",
      24: "ISO studio tungsten",
      255: "Other",
    },
    Flash: {
      0: "Flash did not fire",
      1: "Flash fired",
      5: "Strobe return light not detected",
      7: "Strobe return light detected",
      9: "Flash fired, compulsory flash mode",
      13: "Flash fired, compulsory flash mode, return light not detected",
      15: "Flash fired, compulsory flash mode, return light detected",
      16: "Flash did not fire, compulsory flash mode",
      24: "Flash did not fire, auto mode",
      25: "Flash fired, auto mode",
      29: "Flash fired, auto mode, return light not detected",
      31: "Flash fired, auto mode, return light detected",
      32: "No flash function",
      65: "Flash fired, red-eye reduction mode",
      69: "Flash fired, red-eye reduction mode, return light not detected",
      71: "Flash fired, red-eye reduction mode, return light detected",
      73: "Flash fired, compulsory flash mode, red-eye reduction mode",
      77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
      79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
      89: "Flash fired, auto mode, red-eye reduction mode",
      93: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
      95: "Flash fired, auto mode, return light detected, red-eye reduction mode",
    },
    SensingMethod: {
      1: "Not defined",
      2: "One-chip color area sensor",
      3: "Two-chip color area sensor",
      4: "Three-chip color area sensor",
      5: "Color sequential area sensor",
      7: "Trilinear sensor",
      8: "Color sequential linear sensor",
    },
    SceneCaptureType: { 0: "Standard", 1: "Landscape", 2: "Portrait", 3: "Night scene" },
    SceneType: { 1: "Directly photographed" },
    CustomRendered: { 0: "Normal process", 1: "Custom process" },
    WhiteBalance: { 0: "Auto white balance", 1: "Manual white balance" },
    GainControl: { 0: "None", 1: "Low gain up", 2: "High gain up", 3: "Low gain down", 4: "High gain down" },
    Contrast: { 0: "Normal", 1: "Soft", 2: "Hard" },
    Saturation: { 0: "Normal", 1: "Low saturation", 2: "High saturation" },
    Sharpness: { 0: "Normal", 1: "Soft", 2: "Hard" },
    SubjectDistanceRange: { 0: "Unknown", 1: "Macro", 2: "Close view", 3: "Distant view" },
    FileSource: { 3: "DSC" },
    Components: { 0: "", 1: "Y", 2: "Cb", 3: "Cr", 4: "R", 5: "G", 6: "B" },
  };
function readTags(e, t, r, n, i) {
  let o,
    a,
    s = e.getUint16(r, !i),
    u = {};
  for (let l = 0; l < s; l++) (o = r + 12 * l + 2), (a = n[e.getUint16(o, !i)]), (u[a] = readTagValue(e, o, t, r, i));
  return u;
}
function readTagValue(e, t, r, n, i) {
  let o,
    a,
    s,
    u,
    l,
    d,
    g = e.getUint16(t + 2, !i),
    c = e.getUint32(t + 4, !i),
    S = e.getUint32(t + 8, !i) + r;
  switch (g) {
    case 1:
    case 7:
      if (1 == c) return e.getUint8(t + 8, !i);
      for (o = c > 4 ? S : t + 8, a = [], u = 0; u < c; u++) a[u] = e.getUint8(o + u);
      return a;
    case 2:
      return (o = c > 4 ? S : t + 8), getStringFromDB(e, o, c - 1);
    case 3:
      if (1 == c) return e.getUint16(t + 8, !i);
      for (o = c > 2 ? S : t + 8, a = [], u = 0; u < c; u++) a[u] = e.getUint16(o + 2 * u, !i);
      return a;
    case 4:
      if (1 == c) return e.getUint32(t + 8, !i);
      for (a = [], u = 0; u < c; u++) a[u] = e.getUint32(S + 4 * u, !i);
      return a;
    case 5:
      if (1 == c)
        return (
          (l = e.getUint32(S, !i)),
          (d = e.getUint32(S + 4, !i)),
          (s = new Number(l / d)),
          (s.numerator = l),
          (s.denominator = d),
          s
        );
      for (a = [], u = 0; u < c; u++)
        (l = e.getUint32(S + 8 * u, !i)),
          (d = e.getUint32(S + 4 + 8 * u, !i)),
          (a[u] = new Number(l / d)),
          (a[u].numerator = l),
          (a[u].denominator = d);
      return a;
    case 9:
      if (1 == c) return e.getInt32(t + 8, !i);
      for (a = [], u = 0; u < c; u++) a[u] = e.getInt32(S + 4 * u, !i);
      return a;
    case 10:
      if (1 == c) return e.getInt32(S, !i) / e.getInt32(S + 4, !i);
      for (a = [], u = 0; u < c; u++) a[u] = e.getInt32(S + 8 * u, !i) / e.getInt32(S + 4 + 8 * u, !i);
      return a;
  }
}
function getStringFromDB(e, t, r) {
  let n = "";
  for (let i = t; i < t + r; i++) n += String.fromCharCode(e.getUint8(i));
  return n;
}
function readEXIFData(e, t) {
  let r, n, i, o, a;
  if (18761 == e.getUint16(t)) r = !1;
  else {
    if (19789 != e.getUint16(t)) return !1;
    r = !0;
  }
  if (42 != e.getUint16(t + 2, !r)) return !1;
  const s = e.getUint32(t + 4, !r);
  if (s < 8) return !1;
  if (((n = readTags(e, t, t + s, TiffTags, r)), n.ExifIFDPointer))
    for (i in ((o = readTags(e, t, t + n.ExifIFDPointer, ExifTags, r)), o)) {
      switch (i) {
        case "LightSource":
        case "Flash":
        case "MeteringMode":
        case "ExposureProgram":
        case "SensingMethod":
        case "SceneCaptureType":
        case "SceneType":
        case "CustomRendered":
        case "WhiteBalance":
        case "GainControl":
        case "Contrast":
        case "Saturation":
        case "Sharpness":
        case "SubjectDistanceRange":
        case "FileSource":
          o[i] = StringValues[i][o[i]];
          break;
        case "ExifVersion":
        case "FlashpixVersion":
          o[i] = String.fromCharCode(o[i][0], o[i][1], o[i][2], o[i][3]);
          break;
        case "ComponentsConfiguration":
          o[i] =
            StringValues.Components[o[i][0]] +
            StringValues.Components[o[i][1]] +
            StringValues.Components[o[i][2]] +
            StringValues.Components[o[i][3]];
      }
      n[i] = o[i];
    }
  if (n.GPSInfoIFDPointer)
    for (i in ((a = readTags(e, t, t + n.GPSInfoIFDPointer, GPSTags, r)), a)) {
      if ("GPSVersionID" === i) a[i] = a[i][0] + "." + a[i][1] + "." + a[i][2] + "." + a[i][3];
      n[i] = a[i];
    }
  return n;
}
function findEXIFinHEIC(e) {
  const t = new DataView(e),
    r = t.getUint32(0),
    n = t.getUint32(r);
  let i = -1,
    o = -1;
  for (let e = r; e < n + r; e++) "Exif" == getStringFromDB(t, e, 4) ? (i = e) : "iloc" == getStringFromDB(t, e, 4) && (o = e);
  if (-1 == i || -1 == o) return null;
  const a = t.getUint16(i - 4);
  for (let e = o + 12; e < n + r; e += 16) {
    if (t.getUint16(e) == a) {
      let r = t.getUint32(e + 8),
        n = (t.getUint32(e + 12), 4 + t.getUint32(r));
      return readEXIFData(t, r + n);
    }
  }
  return null;
}
function findEXIFinJPEG(e) {
  const t = new DataView(e),
    r = e.byteLength;
  if (255 != t.getUint8(0) || 216 != t.getUint8(1)) return !1;
  let n,
    i = 2;
  for (; i < r; ) {
    if (255 != t.getUint8(i)) return !1;
    if (((n = t.getUint8(i + 1)), 225 == n)) return readEXIFData(t, i + 4 + 6, t.getUint16(i + 2) - 2);
    i += 2 + t.getUint16(i + 2);
  }
}

window.findEXIFinHEIC = findEXIFinHEIC;
window.findEXIFinJPEG = findEXIFinJPEG;
